import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import { Section } from '@/courses/models/section.model';

@Component({
  components: {
    EdTextViewerOnly: () => import('@/courses/components/ed-text-viewer-only/ed-text-viewer-only.vue'),
  }
})
export default class EdDeckCardSideComponent extends Vue {
  @Prop({ default: null }) readonly side: Section;
  @Prop({ default: false }) readonly isLegacyCard: boolean;

  styles: any = {};

  get cardImageLegacy(): string {
    let imageHash = JSON.parse(this.side.text).background;
    let imageUrl = this.side.assetsInfo.find(el => el.hash == imageHash)?.url;

    return imageUrl ?? '';
  }

  get cardImage(): string {
    let imageHash = JSON.parse(this.side.text).image;
    let imageUrl = this.side.assetsInfo.find(el => el.hash == imageHash)?.url;

    return imageUrl ?? '';
  }

  getImageStyles(imageUrl: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let width = '100%';
      let height = 'auto';
  
      const image = new Image();

      image.onload = () => {
        if (image.width <= image.height) {
          width = 'auto';
          height = '100%';
        }

        resolve({
          width,
          height,
        });
      }
  
      image.onerror = () => {
        resolve({
          width,
          height,
        });
      }

      image.src = imageUrl;
    });
  }

  async init() {
    if (this.isLegacyCard) {
      this.styles = await this.getImageStyles(this.cardImageLegacy);
    }
  }

  created() {
    this.init();
  }
}